import DataType from '@opsbase/lib-datatype/DataType/DataType';
import i18n from '@opsbase/lib-i18n';
import useTeamCreate from '@opsbase/react-gql-hooks/team/useTeamCreate';
import useNewDataActionsContext from '@opsbase/web-ctrl-newdata/useNewDataActions';
import CreateDialog from '@opsbase/web-dialogs/CreateDialog';
import EditableList from '@opsbase/web-editablelist';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import useNav from '@opsbase/web-nav/useNav';
import useNotificationActions from '@opsbase/web-notification/useNotificationActions';
import React, { useCallback, useState } from 'react';
export function TeamCreateDialog() {
    const [items, setItems] = useState([]);
    const createTeam = useTeamCreate();
    const { raise } = useNotificationActions();
    const { goBack } = useNav();
    const { addItemsToType } = useNewDataActionsContext();
    const handleChange = useCallback(newItems => setItems(newItems), []);
    const handleCreate = useCallback(async () => {
        return raise(Promise.all(items.map(async (item) => createTeam({
            patch: { title: item.title },
        }))), i18n.t('team-created-successful'));
    }, [createTeam, items, raise]);
    const handleAfterCreate = useCallback(async (teams) => {
        addItemsToType(DataType.TEAM, teams);
        goBack();
    }, [goBack, addItemsToType]);
    return (React.createElement(CreateDialog, { padded: true, valid: items.length > 0, onCreate: handleCreate, afterCreate: handleAfterCreate, title: i18n.t('create-a-team') },
        React.createElement(Vertical, null,
            React.createElement(Pane, null,
                React.createElement(EditableList, { autoSelectIdx: 0, placeholder: i18n.t('enter-name-of-new-team'), canAddAtBottom: true, canDelete: true, items: items, onChange: handleChange })))));
}
export default TeamCreateDialog;
